import { useEffect, lazy, Suspense } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, useMediaQuery } from '@mui/material';

import { Container } from '~/content/components/Container';
import Headline from './headline';
// const Headline = lazy(() => import('./headline.tsx'));
const Form = lazy(() => import('./form.tsx'));
// import Form from './form';
// import Partners from './partners';
import { trackPageview } from '~/utils/plausible';

const HireUs = (): JSX.Element => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	useEffect(() => {
		trackPageview();
	}, []);
	return (
		<Box>
			<Box
				sx={{
					backgroundColor: theme.palette.alternate.main,
					// backgroundImage: `linear-gradient(120deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 100%)`,
					//? needs to be "-15" bc of older top-topbar
					// marginTop: -15,
					//? padding first element after "Topbar"
					// paddingTop: 20,
					pb: { xs: 0, sm: 3 },
				}}
			>
				<Container maxWidth={1250}>
					<Headline />
				</Container>
			</Box>
			<Container maxWidth={800} sx={{ mb: { xs: -7, sm: 3 }, mt: { xs: 3, sm: 4 } }}>
				<Suspense fallback={<Skeleton variant='rectangular' width={'100%'} height={'100%'} />}>
					<Form />
				</Suspense>
			</Container>
		</Box>
	);
};

export default HireUs;
